<app-bread-crumb></app-bread-crumb>

<!-- <app-news-info *ngIf="Type == 'Type1'" [FunctionID]="FId" [data]="aritcleList.Data"></app-news-info> -->
<!-- <app-announcement-info *ngIf="Type == 'Type2'" [FunctionID]="FId" [data]="aritcleList.Data"></app-announcement-info> -->
<app-unit-news *ngIf="Type == 'Type1'" [FunctionID]="FId" [data]="aritcleList.Data"></app-unit-news>
<app-unit-announcement *ngIf="Type == 'Type2'" [FunctionID]="FId" [data]="aritcleList.Data"></app-unit-announcement>
<app-unit-announcement *ngIf="Type == 'Type3'" [FunctionID]="FId" [data]="aritcleList.Data"></app-unit-announcement>
